import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideZoneChangeDetection } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from '@nrwl/environment';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { appRoutes } from './app/app.routes';
import { TokenInterceptor } from '@nrwl/rx-service-auth';
import { AuthEffects, AuthReducer } from '@nrwl/rx-state-auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    { provide: APP_BASE_HREF, useValue: '/' },
    provideStore({ auth: AuthReducer.authReducer }),
    provideEffects([AuthEffects]),

    !environment.production
      ? provideStoreDevtools() // Optional: enable store devtools in dev mode
      : [],
  ],
};

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
